var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { useRequest } from "./useRequest";
import { API_PATH } from "./useRequest";
import { TeamRankingStatus } from "@/types/teamRanking";
import { useRef, useState } from "@max/max";
import { ACTIVITY_BLOKCED_CODE, ACTIVITY_OFFLINE_CODE } from "@/types/shared";
import { useOrderPopup } from "./useOrderPopup";
import { POPUP_ORDER } from "@/const";
const isWeb = true;
import dayjs from "dayjs";
import { isMiniProgramOrWebview, isWeixinMiniProgramOrWeixinWebview } from "@nibfe/mkt-env-api";
import { USER_INFO_VALID_CODE } from '@/types/shared';
import { navigateTo } from "@max/meituan-uni-navigate";
export const PLAY_TYPE = 27;
export function useTeamRanking(options) {
    var _a;
    const ctx = useMonitorEngineContext();
    const { inviter } = ((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) || {};
    const [done, setDone] = useState(false);
    const [teamRankingStatus, setTeamRankingStatus] = useState(TeamRankingStatus.NOT_STARTED);
    const [teamRankingData, setTeamRankingData] = useState(null);
    const [inTeam, setInTeam] = useState(false);
    const [teamInfo, setTeamInfo] = useState(null);
    const [noticePopupVisible, setNoticePopupVisible] = useOrderPopup(false, POPUP_ORDER.NOTICE);
    const hasNoticed = useRef(false);
    const { requestStatus, request } = useRequest(API_PATH.MAIN);
    const { requestStatus: joinActivityRequestStatus, request: joinActivityRequest } = useRequest(API_PATH.JOIN_ACTIVITY, {
        raw: true
    });
    const isInWxWebview = isWeixinMiniProgramOrWeixinWebview() && !isMiniProgramOrWebview();
    function tryLogin() {
        var _a;
        if (isWeb && isInWxWebview) {
            const backUrl = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) || '';
            navigateTo({
                url: `https://passport.meituan.com/useraccount/ilogin?backurl=${encodeURIComponent(backUrl)}&risk_partner=0&risk_app=-1&risk_platform=3`
            });
        }
        else {
            // ctx._userAPI.login()
        }
    }
    function fetchTeamRankingData() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const params = {
                    activityId: options.activityId,
                    taskId: options.teamRankingId
                };
                if (Number(inviter)) {
                    params.inviter = Number(inviter);
                }
                const res = yield request(params);
                if (!res) {
                    throw new Error('获取战队数据失败');
                }
                const states = calculateStates(res, options.usePushAssist, options.rankingListTime);
                setTeamRankingStatus(states.teamRankingStatus);
                setInTeam(states.inTeam);
                if (states.teamInfo) {
                    setTeamInfo(states.teamInfo);
                }
                if (states.noticePopupVisible && !hasNoticed.current && !options.disableNoticePopup) {
                    setNoticePopupVisible(true);
                    hasNoticed.current = true;
                }
                setTeamRankingData(res);
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    apiPath: API_PATH.MAIN
                });
                return res;
            }
            catch (error) {
                ctx._uiInteractionAPI.toast.show({
                    content: '获取数据失败，请稍后重试'
                });
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: API_PATH.MAIN
                });
                ctx._raptorReport.monitorReportLog(error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
                return null;
            }
            finally {
                setDone(true);
            }
        });
    }
    /**
     * 参与活动（非城市签场景）
     */
    function joinActivity() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const params = {
                    playType: PLAY_TYPE,
                    // 组队打Call玩法
                    activityId: options.activityId,
                    taskId: options.teamRankingId
                };
                const res = yield joinActivityRequest(params);
                if (!(res === null || res === void 0 ? void 0 : res.data)) {
                    throw new Error('参与活动失败');
                }
                if (((_a = res.data) === null || _a === void 0 ? void 0 : _a.code) === 0) {
                    (_c = (_b = ctx._raptorReport).monitorReportBizSuccess) === null || _c === void 0 ? void 0 : _c.call(_b, {
                        apiPath: API_PATH.JOIN_ACTIVITY
                    });
                    return res;
                }
                else if (((_d = res.data) === null || _d === void 0 ? void 0 : _d.code) === ACTIVITY_OFFLINE_CODE || ((_e = res.data) === null || _e === void 0 ? void 0 : _e.code) === ACTIVITY_BLOKCED_CODE) {
                    ctx._uiInteractionAPI.toast.show({
                        content: '活动已经下线了哦'
                    });
                }
                else if (((_f = res.data) === null || _f === void 0 ? void 0 : _f.code) === USER_INFO_VALID_CODE) {
                    tryLogin();
                }
                else {
                    throw new Error(res.message || '参与活动失败');
                }
            }
            catch (error) {
                // 如果创建活动实例失败，则不继续请求其他接口（包括主接口），直接展示兜底
                setDone(true);
                setTeamRankingStatus(TeamRankingStatus.OFFLINE);
                ctx._uiInteractionAPI.toast.show({
                    content: error.message || '参与活动失败，请稍后重试'
                });
                (_h = (_g = ctx._raptorReport).monitorReportBizFailed) === null || _h === void 0 ? void 0 : _h.call(_g, {
                    apiPath: API_PATH.JOIN_ACTIVITY
                });
                ctx._raptorReport.monitorReportLog(error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
                throw error;
            }
        });
    }
    return {
        fetchTeamRankingData,
        joinActivity,
        requestStatus,
        joinActivityRequestStatus,
        teamRankingStatus,
        teamRankingData,
        inTeam,
        teamInfo,
        done,
        noticePopupVisible,
        setNoticePopupVisible
    };
}
function calculateStates(res, usePushAssist, rankingListTime) {
    let teamRankingStatus = TeamRankingStatus.NOT_STARTED;
    const { joinActivity, periodInfo, teamInfo, pushAssist } = (res === null || res === void 0 ? void 0 : res.extra) || {};
    /** 活动状态 */
    const isCalculating = dayjs(rankingListTime).isAfter(dayjs());
    if (res.uni_status_code === ACTIVITY_OFFLINE_CODE || res.uni_status_code === ACTIVITY_BLOKCED_CODE) {
        teamRankingStatus = TeamRankingStatus.OFFLINE;
    }
    else {
        if (periodInfo && !joinActivity) {
            teamRankingStatus = TeamRankingStatus.WON_REWARD;
        }
        else if (periodInfo) {
            teamRankingStatus = TeamRankingStatus.IN_PROGRESS;
        }
        else if (isCalculating) {
            teamRankingStatus = TeamRankingStatus.CALCULATING;
        }
        else {
            teamRankingStatus = TeamRankingStatus.PUBLICITY;
        }
    }
    /** 团队状态 */
    let inTeam = false;
    if (teamInfo) {
        inTeam = true;
    }
    /** 进度通知弹窗，鼓励用户去分享 */
    let noticePopupVisible = false;
    if (!(usePushAssist && pushAssist === false) // 没有到达上限
        && joinActivity // 能够参加活动
        && teamRankingStatus === TeamRankingStatus.IN_PROGRESS // 活动进行中
        && inTeam // 已经加入队伍
        && !(teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.obtainReward) // 没有获得奖励
    ) {
        noticePopupVisible = true;
    }
    return {
        teamRankingStatus,
        inTeam,
        noticePopupVisible,
        teamInfo
    };
}
